import SearchInsightsProvider from 'components/SearchInsightsProvider';
import { Page, PageSource } from 'components/shared/Page/Page';
import { TrailUgcProvider } from 'components/trailUgc/TrailUgcContext';
import Trail from '../pages/Trail';
import useListItems from 'hooks/useListItems';

const TrailPage = props => {
  const { listMethods, renderModal } = useListItems(
    { lists: props.initialMyLists, listItems: props.initialMyListItems },
    props.context,
    'TRAIL_PAGE'
  );

  return (
    <Page pageSource={PageSource.Trail} context={props.context}>
      <SearchInsightsProvider context={props.context} pageName={PageSource.Trail}>
        {renderModal()}
        <TrailUgcProvider
          ugcInfo={{
            reviews: props.reviews?.trail_reviews,
            photos: props.photos,
            tracks: props.tracks?.maps,
            completed: props.completedJson,
            itemTotals: props.itemTotals
          }}
        >
          <Trail listMethods={listMethods} {...props} />
        </TrailUgcProvider>
      </SearchInsightsProvider>
    </Page>
  );
};

export default TrailPage;
